import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { FormattedMessage, injectIntl } from 'react-intl';
import TextInput from './TextInput';
import RadioGroupInput from './RadioGroupInput';
import FormikControlledComboBox from './ComboBox';
import {
  GRID_OPERATORS_AT,
  GRID_OPERATORS_DE,
  GRID_OPERATORS_BOTH,
} from '../../containers/ContactPage/gridOperators';
import formStyles from '../../styles/forms.module.scss';

function getOptionsFromControlArea(controlArea) {
  switch (controlArea) {
    case 'apg':
      return GRID_OPERATORS_AT;
    case 'tennet':
    case '50hertz':
    case 'amprion':
    case 'transnetBW':
      return GRID_OPERATORS_DE;
    default:
      return GRID_OPERATORS_BOTH;
  }
}

function CommonFacilityFields(props) {
  const { namePrefixMin, values, index, form, intl } = props;
  const namePrefix = `${namePrefixMin}[${index}]`;
  const controlArea =
    values[namePrefixMin][index] && values[namePrefixMin][index].controlArea;

  return (
    <>
      <div className={formStyles.inputWithVerticalSpacing}>
        <Field
          captionMsg="offerWizard.regelzone"
          name={`${namePrefix}.controlArea`}
          options={[
            {
              value: 'apg',
              labelText: 'APG',
            },
            {
              value: 'tennet',
              labelText: 'TenneT',
            },
            {
              value: '50hertz',
              labelText: '50 Hertz',
            },
            {
              value: 'amprion',
              labelText: 'Amprion',
            },
            {
              value: 'transnetBW',
              labelText: 'Transnet BW',
            },
            {
              value: 'custom',
              labelText: intl.formatMessage({
                id: 'offerWizard.regelzone.other',
              }),
            },
          ]}
          component={RadioGroupInput}
          radioButtonsWrapperClass={formStyles.controlAreaRadios}
          additionalChangeAction={(e) => {
            const oldValue =
              values[namePrefixMin][index] &&
              values[namePrefixMin][index].controlArea;
            const newValue = e.target.value;
            if (
              oldValue !== newValue &&
              (oldValue === 'apg' ||
                newValue === 'apg' ||
                oldValue === 'custom')
            ) {
              form.setFieldValue(`${namePrefix}.gridOperator`, null);
            }
          }}
        />
        {controlArea === 'custom' && (
          <div className={formStyles.inputPairSingle}>
            <Field
              name={`${namePrefix}.customControlArea`}
              component={TextInput}
              labelMsg="offerWizard.regelzone.otherTextInput"
              required
            />
          </div>
        )}
      </div>
      <div className={formStyles.inputWithVerticalSpacing}>
        <div className={formStyles.inputPairSingle}>
          <Field
            name={`${namePrefix}.gridOperator`}
            component={FormikControlledComboBox}
            options={getOptionsFromControlArea(
              values[namePrefixMin][index] &&
                values[namePrefixMin][index].controlArea
            )}
            labelMsg="offerWizard.gridOperator"
          />
        </div>
      </div>
      <div className={formStyles.inputWithVerticalSpacing}>
        <fieldset>
          <legend className={formStyles.caption}>
            <FormattedMessage id="offerWizard.coordinates" />
          </legend>
          <div className={formStyles.inputPair}>
            <Field
              name={`${namePrefix}.latitude`}
              component={TextInput}
              labelMsg="offerWizard.lat"
              labelPosition="left"
              unit="N"
              id={`${namePrefix}.latitude`}
            />
            <Field
              name={`${namePrefix}.longitude`}
              component={TextInput}
              labelMsg="offerWizard.lon"
              labelPosition="left"
              unit="E"
            />
          </div>
        </fieldset>
      </div>
    </>
  );
}

CommonFacilityFields.defaultProps = {
  form: null,
};

CommonFacilityFields.propTypes = {
  namePrefixMin: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  index: PropTypes.number.isRequired,
  form: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
  }),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(CommonFacilityFields);
